"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const SectionTitle = _styledComponents.default.h3.withConfig({
  displayName: "SectionTitle",
  componentId: "design-system__sc-17tk4gj-0"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";align-self:center;margin:0;padding:0 0 0.5rem 0;* + &{padding-top:2.5rem;}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.large1, _BaseTheme.default.type.weight.regular, _BaseTheme.default.type.lineHeight.none, _BaseTheme.default.colors.gray);

var _default = SectionTitle;
exports.default = _default;